var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Modal, { ModalInner } from "@irati/ui/src/Modal";
export var StyledModal = styled(Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    padding: 0;\n  }\n"], ["\n  ", " {\n    padding: 0;\n  }\n"])), ModalInner);
export var ModalContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 15px;\n"], ["\n  padding: 15px;\n"])));
export var StyledHeader = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  display: flex;\n  padding: 15px;\n"], ["\n  border-bottom: 1px solid ", ";\n  display: flex;\n  padding: 15px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.light;
});
export var StyledFooter = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  padding: 15px;\n  text-align: right;\n"], ["\n  border-top: 1px solid ", ";\n  padding: 15px;\n  text-align: right;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.light;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
